// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29QVL","questions":"styles_questions__3uIbN","footer":"styles_footer__3VaHx"};